import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { DataTable, DateTimeField, Field } from '../../commons/DataTable';
import { BadgeField } from '../../commons/DataTableFields';
import { refactoringAdminLevels } from '../../lib/helpers/refactoringAdminLevels';
import ManagerField from './ManagerField';
import BraceletBadge from '../../commons/DataTable/BraceletBadge';
import CrmBadge from '../../commons/DataTable/CrmBadge';
import moment from 'moment';
import SoftwareBadge from '../../commons/DataTable/SoftwareBadge';

function ProfilesTable({
  history,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  managers = [],
  pathname = '',
}) {
  const [t] = useTranslation('COMMON');
  const { limit, offset } = query;

  const refactorData = data.map((profile) => {
    return {
      ...profile,
      type: refactoringAdminLevels(profile.type),
      bracelet: profile.bracelet && profile.bracelet === true ? true : false,
      crm: profile.crm && profile.crm === true ? true : false,
    };
  });

  for (const profile of data) {
    if (profile.profileScore?.length > 0) {
      const score = profile.profileScore[0];

      const {
        EONScoreAuto,
        insuranceScoreAuto,
        supplierScoreAuto,
        bonusScoreAuto,
        energyAndConsumptionScoreAuto,
        trainingScore = 0,
        trainingCourses = [],
        type,
        EonScoreIsAuto,
        insuranceScoreIsAuto,
        supplierScoreIsAuto,
        EONScoreManual,
        insuranceScoreManual,
        supplierScoreManual,
        certifiedScoreAuto,
      } = score;

      let trainingScoreCalculated = 0;
      if (trainingCourses?.length > 0) {
        const validTrainingCourses = trainingCourses.filter((course) => {
          return course.date && moment(course.date).isAfter(moment());
        });

        trainingScoreCalculated = validTrainingCourses.reduce(
          (acc, course) => (acc += course.credits),
          0
        );
      }
      if (trainingScoreCalculated > 100) {
        trainingScoreCalculated = 100;
      }

      profile['totalScore'] =
        (EonScoreIsAuto === undefined || EonScoreIsAuto === true
          ? EONScoreAuto
          : EONScoreManual) +
        (insuranceScoreIsAuto === undefined || insuranceScoreIsAuto === true
          ? insuranceScoreAuto
          : insuranceScoreManual) +
        (supplierScoreIsAuto === undefined || supplierScoreIsAuto === true
          ? supplierScoreAuto
          : supplierScoreManual) +
        bonusScoreAuto +
        energyAndConsumptionScoreAuto +
        trainingScoreCalculated +
        (certifiedScoreAuto || 0);
    }
  }

  return (
    <DataTable
      limit={limit}
      offset={offset}
      total={total}
      data={refactorData}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      onRowClick={({ _id } = {}) =>
        history.push({
          pathname: `/${pathname}/${_id}`,
          state: { pageBack: `${pathname}` },
        })
      }
    >
      <Field
        title="Ragione Sociale"
        source="businessName"
        className="text-left"
      />
      <Field title="Nome Cognome" source="name" />
      <Field title="Tipologia" source="type" className="type" />
      <Field title="P.IVA / CF." source="taxCode" />
      <ManagerField
        title="Gestore Studio"
        source="studioManager"
        managers={managers}
      />
      <Field title="N. Condomini" source="numberOfCondos" />
      <Field title="N. Clienti" source="numberOfCustomers" />
      <Field title="Crediti" source="totalScore" />
      <BraceletBadge title="Braccialetto" source="bracelet" />
      <CrmBadge title="CRM" source="crm" />
      <SoftwareBadge title="Software" source="software" />
      <BadgeField title="Affiliazione Attiva" source="activeAffiliation" />
      <BadgeField title="Utente attivo" source="isActive" />
      <DateTimeField
        title="Data disdetta"
        source="cancellationDate"
        format="DD/MM/YYYY"
      />
    </DataTable>
  );
}

export default withRouter(ProfilesTable);
